import React from 'react'
import { ResponsiveBar } from '@nivo/bar'
// const datadefault = [
//     {
//       "name": "M1_L1",
//       "correcto": 10,
//       "incorrecto": 20,
//     },
//     {
//       "name": "M1_L2",
//       "correcto": 30,
//       "incorrecto": 13,
//     },
//     {
//       "name": "M1_L3",
//       "correcto": 17,
//       "incorrecto": 22,
//     },
//     {
//       "name": "M1_L4",
//       "correcto": 4,
//       "incorrecto": 18,
//     },
//     {
//       "name": "M1_L5",
//       "correcto": 6,
//       "incorrecto": 16,
//     },
//     {
//       "name": "M1_L6",
//       "correcto": 7,
//       "incorrecto": 8,
//     },
//     {
//       "name": "M2_L1",
//       "correcto": 16,
//       "incorrecto": 11,
//     },
//     {
//       "name": "M2_L2",
//       "correcto": 4,
//       "incorrecto": 15,
//     },
//     {
//       "name": "M2_L3",
//       "correcto": 4,
//       "incorrecto": 14,
//     },
//   ]
export const CardBarCharSimiVR = ({ title, info, type, usersEnd = 1 }) => {
    const data = [];
    Object.keys(info).forEach(key => {
        data.push({
            name:key,
            tiempo: ((info[key].time / info[key].intents)),
            errores: Math.max(0, Math.ceil(info[key].fails / info[key].intents))
        })
    })
    return (
        <div className="w-[376px] h-[432px] bg-white rounded-2xl shadow-sm p-4 text-center">
            <p className="text-black font-semibold text-sm">{title}</p>
            <ResponsiveBar
                data={data.reverse()}
                keys={type === "unique" ? ["errores"] : ["tiempo"]}
                indexBy="name"
                margin={{ top: 5, right: 10, bottom: 50, left: 60 }}

                padding={0.4}
                groupMode="grouped"
                layout="horizontal"
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                colors={type === "unique" ? ['#3366FF'] : ['#8055AE', '#8055AE']}
                borderColor="black"

                axisTop={null}
                axisRight={null}
                axisLeft={{
                    tickValues: 10,
                }}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legendPosition: 'start',
                    legend: type === "unique" ? "Errores" : "Tiempo (seg)",
                    legendOffset: 32,

                    truncateTickAt: 0
                }}
                enableLabel={false}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1.6
                        ]
                    ]
                }}

                role="application"
                ariaLabel="Nivo bar chart demo"
                barAriaLabel={e => e.id + ": " + e.formattedValue + " in name: " + e.indexValue}
            />
        </div>
    )
}
